export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/bafcb97f65150dd63b7cabadb0e0f790.svg";